const area = '/selling';

export default {
    START: `${area}/`,
    CAMPAIGN: `${area}/campaign/:campaignCode`,
    DRAFTS: `${area}/`,
    DRAFT: `${area}/draft/:draftId`,
    DRAFT_SUMMARY: `${area}/summary/:draftId`,
    EDIT_DRAFT_PROPERTIES: `${area}/draft/:draftId/edit/:propertyNames`,
    NEW_DRAFT: `${area}/new`,
    TEMPLATES: `${area}/templates`,
    TEMPLATE: `${area}/template/:templateId`,
    EDIT_TEMPLATE_PROPERTIES: `${area}/template/:templateId/edit/:propertyNames`,
    PUBLISHED: `${area}/published/:itemId`,
    EXTRA: `${area}/extra/:draftId`,
    FEATURES: `${area}/features/:itemId`
};
